// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__bvVJ6","table":"Table_table__Zwon1","row":"Table_row__KdQ-a","col":"Table_col__LzcGS","status":"Table_status__KI5+b"};